import {DealActivityItemBase, Hub} from 'yougile-model'
import {getDealActivity} from '../get-deal-activity'

export const deleteDealActivityItem = (
  hub: Hub,
  item: DealActivityItemBase
): void => {
  if (!getDealActivity(hub)) {
    return
  }

  hub.data.dealActivity ??= {}
  delete hub.data.dealActivity[item.id]
  hub.commit()
}
